import { useCallback } from "react";
import type { IpEvent } from "@/types";

function formatTimestamp(epoch: number): string {
  if (!epoch) return "N/A";
  const d = new Date(epoch * 1000);
  return (
    d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit" }) +
    " " +
    d.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: false })
  );
}

export function useExportCsv(items: IpEvent[]) {
  return useCallback(() => {
    if (!items.length) return;
    const headers = ["IP Address", "Risk Score", "Country Code", "ASN", "Last Activity", "Corroborated", "Action"];
    const rows = items.map((e) => [
      e.ip_address,
      e.fraud_score,
      e.country_code,
      e.metadata.asn ? `${e.metadata.asn} (${e.metadata.as_name})` : "",
      formatTimestamp(e.last_activity),
      e.reported_by_others ? "Yes" : "No",
      e.recommended_action,
    ]);
    const csv = [headers, ...rows].map((r) => r.join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "ip-events.csv";
    a.click();
    URL.revokeObjectURL(url);
  }, [items]);
}
